import { render, staticRenderFns } from "./AppTemplateList.vue?vue&type=template&id=6408ebe2"
import script from "./AppTemplateList.vue?vue&type=script&lang=js"
export * from "./AppTemplateList.vue?vue&type=script&lang=js"
import style0 from "./AppTemplateList.vue?vue&type=style&index=0&id=6408ebe2&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports